import React from 'react';
import FormFill from '../../../components/common/Forms/FormFill';
import { ProtectedRoute, PageGuard } from '../../../components/common/security/ProtectedRoute';

const ConstFormFill: React.FC = () => {
  return (
    <ProtectedRoute>
      <PageGuard>
        <div style={{ padding: 24 }}>
          <FormFill />
        </div>
      </PageGuard>
    </ProtectedRoute>
  );
};

export default ConstFormFill;
